// project import
import 'reflect-metadata';
import Routes from './routes/ThemeRoutes';
import ThemeCustomization from './themes';
import ScrollTop from './components/ScrollTop';
import { SnackbarProvider } from 'notistack';
// ==============================|| APP - THEME, ROUTER, LOCAL  ||============================== //

const App = () => (
    <ThemeCustomization>
        <SnackbarProvider preventDuplicate anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}>
            <ScrollTop>
                <Routes />
            </ScrollTop>
        </SnackbarProvider>
    </ThemeCustomization>
);

export default App;
